import React, { FC } from 'react';
import { styled } from 'linaria/react';
import { withTheme } from '@shared/lib';
import { PaymentMethod } from '@entities/payment';
import { useCyberStore } from '@entities/tsp';
import { mtsPaymentMethodClickGtm, sbpPaymentMethodClickGtm } from '@shared/lib/gtm';
import { Payee } from '@root/api/ump-catalog-manager';
import { oldPaymentMethods } from '../config/oldPaymentMethods';
interface OldPaymentMethodSwitcherProps {
  payee: Payee;
}
const OldPaymentMethodSwitcher: FC<OldPaymentMethodSwitcherProps> = ({
  payee
}) => {
  const {
    paymentMethod,
    setPaymentMethod
  } = useCyberStore();
  const handleClick = (type: PaymentMethod) => {
    if (paymentMethod === type) return;
    if (type === PaymentMethod.SBP) {
      sbpPaymentMethodClickGtm(payee.providerName);
    } else {
      mtsPaymentMethodClickGtm(payee.providerName);
    }
    setPaymentMethod(type);
  };
  return <SwitcherWrapper>
      {oldPaymentMethods.map(({
      type,
      label,
      icon
    }) => <PaymentOption key={type} selected={paymentMethod === type} onClick={() => handleClick(type)}>
          <IconWrapper>{icon}</IconWrapper>
          <Label>{label}</Label>
        </PaymentOption>)}
    </SwitcherWrapper>;
};
export default OldPaymentMethodSwitcher;
interface PaymentOptionProps {
  selected: boolean;
}
const _exp = /*#__PURE__*/() => ({
  selected,
  theme
}) => selected ? theme.colors.bg.secondary : 'none';
const PaymentOption = withTheme(/*#__PURE__*/styled('div')({
  name: "PaymentOption",
  class: "p1tkoud5",
  propsAsIs: false,
  vars: {
    "p1tkoud5-0": [_exp()]
  }
}));
const IconWrapper = /*#__PURE__*/styled('div')({
  name: "IconWrapper",
  class: "i1429wwj",
  propsAsIs: false
});
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primary;
const _exp3 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSWide;
const _exp4 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.xxxxs;
const _exp5 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.bold;
const _exp6 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xs;
const Label = withTheme(/*#__PURE__*/styled('div')({
  name: "Label",
  class: "lrvro3g",
  propsAsIs: false,
  vars: {
    "lrvro3g-0": [_exp2()],
    "lrvro3g-1": [_exp3()],
    "lrvro3g-2": [_exp4(), "px"],
    "lrvro3g-3": [_exp5()],
    "lrvro3g-4": [_exp6(), "px"]
  }
}));
const _exp7 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.bg.primary;
const SwitcherWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "SwitcherWrapper",
  class: "siistkg",
  propsAsIs: false,
  vars: {
    "siistkg-0": [_exp7()]
  }
}));

require("./OldPaymentMethodSwitcher.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./OldPaymentMethodSwitcher.tsx");